import {
  DurationSeries,
  DurationSeriesImpl,
} from "firefly-shared-ts-timeseries";
import { merge } from "lodash";
import { useMemo } from "react";
import { YAxis } from "@mui/x-charts-premium";

type ReturnType = Array<YAxis>;
const defaultWidth = 50;
export const resolveYAxisConfig = (
  series: Array<DurationSeries<number | null>> | undefined,
  axisConfigs?: Array<YAxis<"linear">>
): ReturnType => {
  if (series === undefined || series.length === 0) {
    return [
      {
        max: 100,
        data: [],
        width: defaultWidth,
      } as YAxis,
    ] as ReturnType;
  }

  const firstSeries = series.length > 0 ? series[0] : undefined;

  if (axisConfigs == null) {
    return [
      {
        width: defaultWidth,
        max: (DurationSeriesImpl.getMaxY(series, 0) ?? 0) + 20,
      },
    ] as ReturnType;
  }

  return axisConfigs.map((givenConfig) => {
    const max =
      givenConfig.max != null && typeof givenConfig.max === "number"
        ? givenConfig.max
        : (DurationSeriesImpl.getMaxY<number | null>(series, 0) ?? 0) + 20;

    const valueFormatter =
      givenConfig.valueFormatter != null
        ? givenConfig.valueFormatter
        : firstSeries !== undefined
        ? (value: number) => `${value} ${firstSeries.info.unit}`
        : undefined;

    const defaultConfig: YAxis = {
      width: defaultWidth,
      max: max,
      valueFormatter: valueFormatter,
    };
    return merge(defaultConfig, givenConfig);
  });
};

export const useYAxis = (
  durationSeries: Array<DurationSeries<number | null>> | undefined,
  axisConfig?: Array<YAxis<"linear">>
) => {
  return useMemo(() => {
    return resolveYAxisConfig(durationSeries, axisConfig);
  }, [durationSeries, axisConfig]);
};
